import { Component, OnInit } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserService } from '../admin/user.service';
import { Observable } from 'rxjs/Observable';
import { TdDialogService } from '@covalent/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
/*

*/


@Component({
  selector: 'app-homescreen',
  templateUrl: './homescreen.component.html',
  styleUrls: ['./homescreen.component.scss'],
  providers: [UserService]
})
export class HomescreenComponent implements OnInit {
  printers$: Observable<any[]>;
  printer_id: number;
  csv_separator: string = 'semicolon';
  public version: string = environment.VERSION;
  public _prod: boolean = environment.production;

  constructor(public _authService: AuthenticationService,
    private _userService: UserService,
    private router: Router,
    private _dialog: TdDialogService) { 
    }

  ngOnInit() {
    this.printers$ = this._userService.getPrinters();
    this.printer_id = this._authService.getPrinterId();
    this.csv_separator = this._authService.getCsvSeparator();

  }

  setPrinter() {
    this._userService.getOneUser(this._authService.getUser().id).subscribe(
      _usr => {
        _usr.printer_id = this.printer_id;

        this._userService.updateOneUser(_usr).subscribe(
          response => {
            this._dialog.openAlert({ title: 'SUCCESS', message: 'Printer updated' });
          },
          error => {
            this._dialog.openAlert({ title: 'ERROR', message: 'Printer could not be updated' });
          }
        );
      },
      error => {
        this._dialog.openAlert({ title: 'ERROR', message: 'Could not fetch user info' });
      }
    );
  }

  setCsvSeparator() {
    this._userService.getOneUser(this._authService.getUser().id).subscribe(
      _usr => {
        _usr.csv_separator = this.csv_separator;

        this._userService.updateOneUser(_usr).subscribe(
          response => {
            this._dialog.openAlert({ title: 'SUCCESS', message: 'CSV separator updated' });
          },
          error => {
            this._dialog.openAlert({ title: 'ERROR', message: 'CSV separator could not be updated' });
          }
        );
      },
      error => {
        this._dialog.openAlert({ title: 'ERROR', message: 'Could not fetch user info' });
      }
    );
  }

  updatePassword() {
    console.log('Password Reset');
    this._dialog.openPrompt({
      title: 'Enter new password',
      message: 'Please enter your new password'
    }).afterClosed().subscribe(
      result => {
        if (result) {
          this._userService.changePassword(this._authService.getUser().id, result).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                this._dialog.openAlert({
                  title: 'Success!',
                  message: 'Password changed successfully. Log in with your new password'
                }).afterClosed().subscribe(
                  c => {
                    this.router.navigate(['/login']);
                  }
                );
              } else {
                this._dialog.openAlert({
                  title: 'Failed!',
                  message: 'Password could not be changed'
                });
              }
            }
          );
        }
      },
      error => {
        this._dialog.openAlert({
          title: 'Failed!',
          message: 'Password could not be changed'
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/homescreen/homescreen.component.ts